import { AHText, Box, useSpaceSize, useWidgetTitleHeight } from "arkh";
import React from "react";
import { useNoteWidgetPageTextStyle } from "./styleHelpers/useNoteWidgetStyle";
import { graphql, useFragment } from "react-relay";
import { WidgetNotePage_widgetNotePage$key } from "./__generated__/WidgetNotePage_widgetNotePage.graphql";
import { WidgetNotePageBackground } from "./WidgetNotePageBackground";
import { useWidgetNoteTextTopPadding } from "./useWidgetNoteTextTopPadding";

export const WidgetNotePage = React.memo(WidgetNotePageC);
function WidgetNotePageC(props: { page: WidgetNotePage_widgetNotePage$key }) {
  const page = useFragment(
    graphql`
      fragment WidgetNotePage_widgetNotePage on WidgetNotePage {
        id
        currentValue
        version
        ...useNoteWidgetStyleText_widgetNotePage
        ...WidgetNotePageBackground_widgetNotePage
      }
    `,
    props.page
  );

  const textStyle = useNoteWidgetPageTextStyle(page);

  const padding = useSpaceSize("medium");
  const paddingTop = useWidgetNoteTextTopPadding();

  return (
    <>
      <Box
        style={{
          flex: 1,
          height: "100%",
          justifyContent: "center",
          overflow: "hidden",
        }}
        cornerRadius="medium"
        color="darkText"
      >
        <WidgetNotePageBackground page={page} />
        {page.currentValue && page.currentValue.length > 0 ? (
          <Box
            style={{
              flex: 1,
              overflow: "visible",
              height: "100%",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            <AHText
              allowFontScaling={false}
              size={textStyle.fontSize}
              style={[
                {
                  paddingLeft: padding,
                  paddingRight: padding,
                  paddingBottom: padding,
                  paddingTop,
                  color: textStyle.color,
                  overflow: "visible",
                  flex: 1,
                  width: "100%",

                  fontStyle: textStyle.fontStyle,
                  fontFamily: textStyle.fontFamily,
                  textAlign: textStyle.textAlign,
                },

                textStyle.textShadow,
              ]}
            >
              {page.currentValue}
            </AHText>
          </Box>
        ) : null}
      </Box>
    </>
  );
}
